import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { toIdString } from '../../utils/common';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const FORM_ID = 'adminPricingSettingsEditForm';

export default class AdminPricingSettingsForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateSettingsFunction: PropTypes.func.isRequired,
    cancelFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { updateSettingsFunction } = this.props;
    updateSettingsFunction(params);
  };

  renderSelect = ({ input, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        <strong>{label}</strong> {touched && error && <span>| {error}</span>}
      </label>
      <div>
        <select {...input} id={toIdString(label)}>
          <option value="true">Enabled</option>
          <option value="false">Disabled</option>
        </select>
      </div>
    </div>
  );

  render() {
    const { invalid, submitting, cancelFunction, handleSubmit } = this.props;

    return (
      <Form id={FORM_ID} className="form-inline" onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <div className="form-group">
            <Field
              name="revShareVal"
              type="text"
              component={InputField}
              label="Rev Share"
              placeholder="0"
            />
            <div>
              <Field name="pricingEnabledVal" component={this.renderSelect} label="Pricing" />
              <button type="button" className="btn btn-secondary escape" onClick={cancelFunction}>
                Cancel
              </button>&nbsp;
              <button
                type="submit"
                className="btn btn-primary"
                disabled={checkButtonDisabled(invalid, submitting)}
              >
                Update
              </button>
            </div>
          </div>
        </fieldset>
      </Form>
    );
  }
}
